import { render, staticRenderFns } from "./ApplicantProfileHeader.vue?vue&type=template&id=64169482"
import script from "./ApplicantProfileHeader.vue?vue&type=script&lang=js"
export * from "./ApplicantProfileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports